export default __webpack_public_path__ + "locales/sk/ChangePasswordDialog.json?hash=b8b4848bfe612477175ca845d18b712f";